"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_router_1 = require("vue-router");
var element_plus_1 = require("element-plus");
var indexView_vue_1 = __importDefault(require("@/layout/indexView.vue"));
var hidden = true;
var routes = [
    {
        path: '/',
        name: 'App',
        component: indexView_vue_1.default,
        meta: {
            title: "吟一",
        },
        redirect: "/home",
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    title: "系统首页",
                    icon: "HomeFilled"
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/HomeView.vue')); }); }
            },
            // {
            //   path: '/tasks',
            //   name: 'tasks',
            //   meta: {
            //     title: "任务管理",
            //     icon: "SetUp"
            //   },
            //   component: () => import('@/views/tasks/IndexView.vue')
            // },
            // {
            //   path: '/book-store/books',
            //   name: 'books',
            //   meta: {
            //     title: "书籍管理",
            //     icon: "Memo"
            //   },
            //   component: () => import('@/views/book-store/IndexView.vue')
            // },
            // {
            //   path: '/book-store/borrow-books',
            //   name: 'BorrowBooks',
            //   meta: {
            //     title: "借书管理",
            //     icon: "Collection"
            //   },
            //   component: () => import('@/views/book-store/BorrowBooks.vue')
            // },
            {
                path: '/ancient/poetry',
                name: 'ancientPoetry',
                meta: {
                    title: "古诗学习",
                    icon: "Document"
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/ancient-poetry/IndexView.vue')); }); },
            },
            {
                path: '/ancient/poetry/detail',
                name: 'ancientPoetryDetail',
                meta: {
                    title: "古诗详情",
                    parent: "古诗学习",
                    parentPath: "/ancient/poetry",
                    hidden: hidden
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/ancient-poetry/page/poetryDetail.vue')); }); },
            },
            {
                path: '/ancient/famous',
                name: 'FamousView',
                meta: {
                    title: "古籍名句",
                    icon: "MagicStick"
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/ancient-poetry/FamousView.vue')); }); },
            },
            {
                path: '/ancient/famous/detail',
                name: 'famousDetail',
                meta: {
                    title: "名句集",
                    parent: "古籍名句",
                    parentPath: "/ancient/famous",
                    hidden: hidden
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/ancient-poetry/page/famousDetail.vue')); }); },
            },
            {
                path: '/ancient/books',
                name: 'ancientBooks',
                meta: {
                    title: "古籍学习",
                    icon: "Notebook"
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/ancient-poetry/AncientBooks.vue')); }); },
            },
            {
                path: '/ancient/poetry/book',
                name: 'ancientBookDetail',
                meta: {
                    title: "古籍详情",
                    parent: "古籍学习",
                    parentPath: "/ancient/books",
                    hidden: hidden
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/ancient-poetry/page/bookDetail.vue')); }); },
            },
            {
                path: '/user-center',
                name: 'UserCenter',
                meta: {
                    title: "用户中心",
                    icon: "UserFilled"
                },
                component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/UserCenter.vue')); }); }
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: function () { return Promise.resolve().then(function () { return __importStar(require('@/views/Login.vue')); }); }
    },
];
var router = (0, vue_router_1.createRouter)({
    history: (0, vue_router_1.createWebHashHistory)(process.env.BASE_URL),
    routes: routes
});
router.beforeEach(function (to, from, next) {
    if (!localStorage.getItem("token") && to.path !== '/login') {
        next("/login");
        element_plus_1.ElNotification.error({
            title: '令牌为空',
            message: '认证信息不可用，请重新登录',
            duration: 0
        });
    }
    else {
        next();
    }
});
exports.default = router;
